<template>
    <div class="scheme-list-page">
        <div class="page-header">
            <span class="page-title">实战超市方案</span>
            <div class="header-actions">
                <el-button icon="el-icon-refresh" size="small" :loading="loading" @click="loadList">刷新</el-button>
                <el-button v-if="hasManager" type="primary" icon="el-icon-plus" size="small"
                    @click="openPublish">发布方案</el-button>
                <el-tooltip v-else content="仅彩票经理可发布实战超市方案，请先申请并通过彩票经理认证" placement="bottom">
                    <el-button type="primary" icon="el-icon-plus" size="small" disabled>发布方案</el-button>
                </el-tooltip>
            </div>
        </div>

        <el-table class="scheme-table" :data="list" border v-loading="loading"
            :header-cell-style="{ background: '#347caf', color: '#fff', textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column type="index" label="#" width="50" />
            <el-table-column prop="title" label="方案标题" min-width="160" show-overflow-tooltip />
            <el-table-column label="彩种" width="100">
                <template slot-scope="scope">{{ preTypeLabel(scope.row.preType) }}</template>
            </el-table-column>
            <el-table-column prop="preNumber" label="期号" width="120" />
            <el-table-column prop="teamName" label="团队名称" min-width="120" show-overflow-tooltip />
            <el-table-column label="价格(缩币)" width="110">
                <template slot-scope="scope">{{ scope.row.coin != null && scope.row.coin !== '' ? scope.row.coin : '-'
                    }}</template>
            </el-table-column>
            <el-table-column label="限购(份)" width="100">
                <template slot-scope="scope"> {{ scope.row.inventory }}/{{ scope.row.purchaseLimit != null &&
                    scope.row.purchaseLimit !== '' ?
                    scope.row.purchaseLimit : '-' }}</template>
            </el-table-column>
            <el-table-column label="状态" width="90">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.expired" type="danger" size="mini">已过期</el-tag>
                    <el-tag v-else :type="isOnline(scope.row) ? 'success' : 'info'" size="mini">
                        {{ isOnline(scope.row) ? '已上架' : '未上架' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
                    <el-button type="text" size="mini" style="color:#67c23a"
                        v-if="!isOnline(scope.row) && !scope.row.expired"
                        @click="handleOnline(scope.row)">上架</el-button>
                    <el-button type="text" size="mini" style="color:#e6a23c" v-if="isOnline(scope.row)"
                        @click="handleOffline(scope.row)">下架</el-button>
                    <el-button type="text" size="mini" style="color:#f56c6c"
                        @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pager" background layout="total, prev, pager, next" :total="total" :page-size="pageSize"
            :current-page="pageNum" @current-change="handlePageChange" />

        <!-- 发布 / 编辑 弹窗（内嵌当前发布页） -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="900px" append-to-body
            @close="onDialogClose">
            <RepresentativeApply v-if="dialogVisible" :edit-data="currentEdit" @published="onPublished" />
        </el-dialog>
    </div>
</template>

<script>
import RepresentativeApply from '@/views/personalCenter/tzz_bangfu/RepresentativeApply.vue'
import {
    getMySchemeList, onlineScheme, offlineScheme, deleteScheme
} from '@/api/personalCenter'

export default {
    name: 'MySchemeList',
    components: { RepresentativeApply },
    data() {
        return {
            list: [],
            total: 0,
            pageNum: 1,
            pageSize: 10,
            loading: false,
            dialogVisible: false,
            currentEdit: null,
            // 是否彩票经理（审核通过且在用）：非经理禁用发布入口
            hasManager: false
        }
    },
    computed: {
        dialogTitle() {
            return this.currentEdit ? '编辑实战超市方案' : '发布实战超市方案'
        }
    },
    mounted() {
        this.loadIdentity()
        this.loadList()
    },
    methods: {
        // 拉取帮扶身份，决定是否开放「发布方案」入口（后端同样会强校验）
        loadIdentity() {
            const userId = this.vuex_userInfo && this.vuex_userInfo.userId
            if (userId === undefined || userId === null || userId === '') return
            this.$http.get('/stage-api/assist/person/identity', { params: { userId: Number(userId) } })
                .then(res => {
                    const data = res && res.data !== undefined ? res.data : res
                    this.hasManager = !!(data && data.hasManager)
                })
                .catch(() => {
                    this.hasManager = false
                })
        },
        // 加载我发布的方案列表
        loadList() {
            this.loading = true
            getMySchemeList({ pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
                const base = res && res.data !== undefined ? res.data : res
                if (base && Array.isArray(base.rows)) {
                    this.list = base.rows
                    this.total = base.total || base.rows.length
                } else if (base && Array.isArray(base.list)) {
                    this.list = base.list
                    this.total = base.total || base.list.length
                } else if (Array.isArray(base)) {
                    this.list = base
                    this.total = base.length
                } else {
                    this.list = []
                    this.total = 0
                }
            }).catch(() => {
                this.list = []
                this.total = 0
            }).finally(() => {
                this.loading = false
            })
        },

        handlePageChange(page) {
            this.pageNum = page
            this.loadList()
        },

        // 彩种字典值转中文
        preTypeLabel(val) {
            if (val === '0' || val === 0) return '双色球'
            if (val === '1' || val === 1) return '大乐透'
            return val || '-'
        },

        // 是否上架（兼容多种状态字段名）
        isOnline(row) {
            const s = row.status
            if (s === 1 || s === '1' || s === true) return true
            if (row.onlineStatus === 1 || row.onlineStatus === '1') return true
            if (row.isOnline === 1 || row.isOnline === '1') return true
            return false
        },

        // 打开发布弹窗
        openPublish() {
            if (!this.hasManager) {
                this.$message.warning('仅彩票经理可发布实战超市方案，请先申请并通过彩票经理认证')
                return
            }
            this.currentEdit = null
            this.dialogVisible = true
        },

        // 打开编辑弹窗
        openEdit(row) {
            this.currentEdit = row
            this.dialogVisible = true
        },

        // 子组件发布/修改成功后：关闭弹窗并刷新列表
        onPublished() {
            this.dialogVisible = false
            this.loadList()
        },

        // 弹窗关闭时同步清空编辑态
        onDialogClose() {
            this.currentEdit = null
        },

        // 上架
        handleOnline(row) {
            this.$confirm('确认上架该方案？', '提示', { type: 'warning' }).then(() => {
                onlineScheme(row.marketId || row.id).then(res => {
                    if (res && res.code == 200) {
                        this.$message.success('上架成功')
                        this.loadList()
                    } else {
                        this.$message.error((res && res.msg) || '上架失败')
                    }
                }).catch(() => { })
            }).catch(() => { })
        },

        // 下架
        handleOffline(row) {
            this.$confirm('确认下架该方案？', '提示', { type: 'warning' }).then(() => {
                offlineScheme(row.marketId || row.id).then(res => {
                    if (res && res.code == 200) {
                        this.$message.success('下架成功')
                        this.loadList()
                    } else {
                        this.$message.error((res && res.msg) || '下架失败')
                    }
                }).catch(() => { })
            }).catch(() => { })
        },

        // 删除
        handleDelete(row) {
            this.$confirm('确认删除该方案？删除后不可恢复', '提示', { type: 'warning' }).then(() => {
                deleteScheme(row.marketId || row.id).then(res => {
                    if (res && res.code == 200) {
                        this.$message.success('删除成功')
                        this.loadList()
                    } else {
                        this.$message.error((res && res.msg) || '删除失败')
                    }
                }).catch(() => { })
            }).catch(() => { })
        }
    }
}
</script>

<style lang="scss" scoped>
.scheme-list-page {
    padding: 14px;
    background: #fff;

    .page-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        .page-title {
            font-size: 17px;
            font-weight: 600;
            color: #347caf;
        }

        .header-actions {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .scheme-table {
        margin-bottom: 12px;
    }

    .pager {
        text-align: right;
    }
}
</style>
